$(document).on('click', '.js-tabsLink', function(){
  let _this = $(this),
    content = $('' + _this.data('tab-link') + '');

  _this.parents('.js-tabs').find('.js-tabsLink').removeClass('active');
  _this.addClass('active');

  content
    .show()
    .siblings()
    .hide();

  return false;
});

if (window.innerWidth > 767) {
  $(document).on('mouseenter', '.js-hoverTabsLink', function(){
    let _this = $(this),
      content = $('' + _this.data('tab-link') + '');

    _this.parents('.js-tabs').find('.js-hoverTabsLink').removeClass('active');
    _this.addClass('active');

    content
      .show()
      .siblings()
      .hide();

    return false;
  });
}
